import React, { useState, useEffect, useRef } from "react";
import { TextField, IconButton, InputAdornment } from "@mui/material";
import { useDebounce } from "use-debounce";
import ClearIcon from "@mui/icons-material/Clear";

const FilterInput = ({ label, filterKey, filterValue, onFilterChange, debounceTime = 500, size = "medium", style = {} }) => {
  const [inputValue, setInputValue] = useState(filterValue || "");
  const prevDebouncedValue = useRef(inputValue);
  const [debouncedValue] = useDebounce(inputValue, debounceTime);

  useEffect(() => {
    if (prevDebouncedValue.current !== debouncedValue) {
      prevDebouncedValue.current = debouncedValue;
      onFilterChange(filterKey, debouncedValue || ""); 
    }
  }, [debouncedValue, filterKey, onFilterChange]);

  const handleInputChange = (e) => setInputValue(e.target.value);
  const handleClearInput = () => {
    setInputValue("");
    onFilterChange(filterKey, "");
  };

  return (
    <TextField
      label={label}
      variant="outlined"
      value={inputValue}
      onChange={handleInputChange}
      fullWidth={false} // Allows resizing
      size={size} // Supports "small" or "medium"
      style={{ width: "200px", ...style }} // Default width, can be overridden
      InputProps={{
        endAdornment: inputValue && (
          <InputAdornment position="end">
            <IconButton onClick={handleClearInput} size="small">
              <ClearIcon fontSize="small" />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};

export default FilterInput;
